/**
 * @desc 模拟物流匹配
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsMatchResponseDto>;
export function request(body: defs.tms.LogisticsMatchTestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/test/simulateLogisticsMatch`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
